/*
 * soldout-variant-swap.js
 * When a shopper selects a SOLD-OUT variant on a product that still has other
 * variants in stock, swap the (hidden) buy button for the sold-out signup form,
 * mirroring the behaviour of a fully sold-out product. Restores the buy button
 * when an available variant is selected again.
 *
 * Server-side rendering (blocks/buy-buttons.liquid + blocks/sold-out-signup.liquid)
 * already handles the initial page load / direct variant links; this only covers
 * client-side variant switching (no reload). Classic script, no imports.
 */
(function () {
  if (window.__soldoutVariantSwap) return;
  window.__soldoutVariantSwap = true;

  function findScope(picker) {
    if (picker && picker.closest) {
      var s = picker.closest('[id^="ProductInformation"]');
      if (s) return s;
    }
    return document;
  }

  document.addEventListener(
    'shopify:product:select',
    function (event) {
      var picker = event.target;
      // Ignore product cards / quick-add dialogs — only the main product form.
      if (picker && picker.closest && (picker.closest('product-card') || picker.closest('quick-add-dialog'))) {
        return;
      }
      if (!event.promise || typeof event.promise.then !== 'function') return;

      event.promise
        .then(function (resolved) {
          var detail = resolved && resolved.detail;
          if (!detail || !detail.html) return;

          var html = detail.html;
          var resource = detail.resource;
          var soldOut = resource == null || resource.available === false;

          var scope = findScope(picker);
          var buyBlock = scope.querySelector('.buy-buttons-block');
          var liveSignup = scope.querySelector('.sold-out-signup');

          // "Kommer snart": the whole product is unbuyable regardless of the
          // selected variant — leave the signup form (and the missing buy
          // button) exactly as the server rendered them.
          if (liveSignup && liveSignup.dataset.comingSoon === 'true') return;
          var newSignup = html.querySelector('.sold-out-signup');

          if (buyBlock) buyBlock.hidden = soldOut;

          if (soldOut) {
            if (newSignup) {
              var clone = newSignup.cloneNode(true);
              if (liveSignup) {
                liveSignup.replaceWith(clone);
              } else if (buyBlock) {
                buyBlock.insertAdjacentElement('beforebegin', clone);
              } else {
                scope.appendChild(clone);
              }
            }
            var shown = scope.querySelector('.sold-out-signup');
            if (shown) {
              shown.hidden = false;
              shown.style.removeProperty('display');
            }
          } else if (liveSignup) {
            // The block's own CSS (display:flex) beats the [hidden] attribute,
            // so remove the node entirely — matching the server, which renders
            // no signup for an available variant.
            liveSignup.remove();
          }
        })
        .catch(function () {
          /* variant fetch aborted/failed — leave the DOM as the theme left it */
        });
    },
    false
  );
})();
